import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner } from '@onefootprint/ui';
import type { FieldError } from 'react-hook-form';
import ErrorIndicator from './components/error-indicator';
type ValidationStatusProps = {
  shouldShowLoading: boolean;
  fieldError: FieldError | undefined;
};
const ValidationStatus = t0 => {
  const $ = _c(3);
  const {
    shouldShowLoading,
    fieldError
  } = t0;
  if (shouldShowLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <LoadingSpinner className="flex-shrink-0" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (fieldError) {
    let t1;
    if ($[1] !== fieldError) {
      t1 = <ErrorIndicator fieldError={fieldError} />;
      $[1] = fieldError;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  return null;
};
export default ValidationStatus;